export interface IBleExtensionMessage<T> {
    id: number,
    data: IBleExtensionMessageData<T>
}

export interface IBleDeviceMessageDataBase {
    type: string
}

export interface IErrorDetails {
    errorCode: BleExtensionErrorCode,
    errorMessage: string
}
export interface IBleExtensionMessageData<T> extends IBleDeviceMessageDataBase {    
    id?: string,
    service?: string,
    characteristic?: string,
    value?: string,
    error?: IErrorDetails,
    notifyValue?: boolean,
    response?: T,
    sourceUrl?: string,
    name?: string,
}

export interface IBleCharacteristicNotifyStateResponse {
    characteristic: string,
    isNotifying: boolean,
    errorCode: string
}

export interface IBleCharacteristicReadStoredDataResponse {
    characteristic: string,
    characteristicData: string,
    errorCode: string,
    timestamp: string
}

export interface IBleServiceScanningResponse {
    isScanning: boolean
}

export interface IBleDeviceServicesResponse {
    services: IBleDeviceService[]
}

export interface IBleDeviceService{
    id: string,
    isPrimary: boolean 
}

export interface IBleDeviceServiceCharacteristicsResponse {
    characteristics: IBleDeviceServiceCharacteristic[]
}

export interface IBleDeviceServiceCharacteristic{
    id: string,
    properties: any[]
}

export interface IBleServiceDiscoveredDevicesResponse {
    discoveredDevices: [IBleDeviceDescription]
}

export interface IBleServiceConnectedDevicesResponse {
    connectedDevices: [IBleDeviceDescription]
}

export interface IBleDeviceConnectionStatusResponse {
    connectionStatus: BleDeviceConnectionStatus
}

export interface IBleDeviceDescription {
    id: string,
    name: string,
    services?: [string],
    characteristics?: [string],
    rssi: number,
    connectionStatus: BleDeviceConnectionStatus,
}

export enum BleDeviceConnectionStatus {
    CONNECTED = 'connected',
    CONNECTING = 'connecting',
    DISCONNECTING = 'disconnecting',
    DISCONNECTED = 'disconnected'
}

export enum BleExtensionErrorCode {
    cantParseTheRequest = 1,
    cantRetrieveMessage,
    cantRetrieveMessageType,
    notEnoughDataProvidedToCompleteRequest,
    cantFindDataForTheRequest,
    failedDataConversion,
}